import { Component, OnInit, ViewChild } from '@angular/core';
import {
  FormGroup,
  FormControl,
  FormBuilder,
  NgForm,
  Validators,
  ValidatorFn,
  AbstractControl,
} from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { MatTab, MatTabGroup, MatTabHeader } from '@angular/material/tabs';
import { ActivatedRoute, Router } from '@angular/router';
import { DropdownItem } from 'projects/admin/src/app/models/commonModel';
import {
  ConfirmationTab,
  InternalTabTypes,
  LicenseTab,
  MailingAddressTab,
  PaymentTab,
  PhysicalAddressTab,
  QualificationTab,
  SignatureTab,
} from 'projects/admin/src/app/models/exemptionFilling';
import { WarningModalComponent } from 'projects/admin/src/app/shared/warning-modal/warning-modal.component';
import { YesNoModalComponent } from 'projects/admin/src/app/shared/yes-no-modal/yes-no-modal.component';
import { forkJoin } from 'rxjs';
import { ConfirmModalComponent } from '../../shared/component/confirm-modal/confirm-modal.component';
import { WarningApplicationComponent } from '../../shared/component/warning-application/warning-application.component';
import { ExternalFilingRequestService } from '../../shared/services/exemptionFilingRequest';
import { ExternalCommonService } from '../../shared/services/external.common.service';

@Component({
  selector: 'app-request-copy',
  templateUrl: './request-copy.component.html',
  styleUrls: ['./request-copy.component.scss'],
})
export class RequestCopyComponent implements OnInit {
  form!: FormGroup;
  QualificationTab!: FormGroup;
  RequestCopyTab!: FormGroup;
  SignatureTab!: FormGroup;
  ConfirmationTab!: FormGroup;
  PaymentTab!: FormGroup;
  verificationError = '';

  data: any;
  isDynamicValidationAdded = false;
  qualificationTypes: DropdownItem[] = [];
  countyTypes: DropdownItem[] = [];
  countryTypes: DropdownItem[] = [];
  stateTypes: DropdownItem[] = [];
  cityTypes: DropdownItem[] = [];
  allCites: DropdownItem[] = [];
  paymentTypes: DropdownItem[] = [];
  requestStatusTypes: DropdownItem[] = [];
  externalStatusTypes: DropdownItem[] = [];
  requestTypes: DropdownItem[] = [];
  qualTypeForEntityControl = [
    'OFFICERCORP',
    'MEMBERLLC',
    'FAMILYOWNER',
    'PARTNERLLP',
    'RELSECTBUSINESSENT'
  ];
  selectedTab: InternalTabTypes = InternalTabTypes.VerificationTab;
  @ViewChild('tabs') tabs!: MatTabGroup;
  selectedIndex: number = 0;
  requestId: number = 0;
  isLoading = false;
  isVolRevocation = false;
  constructor(
    private dialog: MatDialog,
    private fb: FormBuilder,
    private router: ActivatedRoute,
    private exemptionFilingRequestService: ExternalFilingRequestService,
    private commonService: ExternalCommonService,
    private routerService: Router
  ) {}

  ngAfterViewInit(): void {
    setTimeout(() => {
      console.log(this.tabs);
      this.tabs._handleClick = this.interceptTabChange.bind(this);
    });
  }
  oninjuryModeSelected(value: any) {
    this.ConfirmationTab.controls['doHaveInjury'].patchValue(value);
    this.ConfirmationTab.controls['doHaveInjury'].updateValueAndValidity();
  }

  sendToModeSelected(value: number) {
    this.RequestCopyTab.controls['sendToMode'].patchValue(value);
    this.RequestCopyTab.controls['sendToMode'].updateValueAndValidity();
    if (value) {
      if (value == 4) {
        this.addValidators(
          'RequestCopyTab',
          'sendToAddressLine1',
          Validators.required
        );
        this.addValidators('RequestCopyTab', 'sendToCity', Validators.required);
        this.addValidators(
          'RequestCopyTab',
          'sendToState',
          Validators.required
        );
        this.addValidators(
          'RequestCopyTab',
          'sendToZipCode',
          Validators.required
        );
      } else {
        this.clearValidators('RequestCopyTab', 'sendToAddressLine1');
        this.clearValidators('RequestCopyTab', 'sendToCity');
        this.clearValidators('RequestCopyTab', 'sendToState');
        this.clearValidators('RequestCopyTab', 'sendToZipCode');
      }
    }
  }

  private loadData() {
    this.loadTypesData();
    this.isLoading = true;
    forkJoin({
      exemptionData:
        this.exemptionFilingRequestService.getExemptionFilingRequestDetail(
          this.requestId
        ),
      reqTypes: this.commonService.getRequestTypes(),
      countyty: this.commonService.getCountyTypes(),
      cty: this.commonService.getCityTypes(),
      stats: this.commonService.getStateTypes(),
    }).subscribe(({ exemptionData, reqTypes, cty, countyty, stats }) => {
      console.log(history);
      this.requestTypes = reqTypes;
      this.countyTypes = countyty;
      this.allCites = cty;
      this.stateTypes = stats;
      this.populateFormData(exemptionData);
      this.isLoading = false;
    });
  }
  private populateFormData(res: any) {
    if (res?.exemptionRequestType?.code == 'VOLREVOCATION') {
      this.isVolRevocation = true;
    }
    setTimeout(() => {
      this.data = res;
      this.form.patchValue(this.data);
      this.QualificationTab.patchValue(this.data);
      this.RequestCopyTab.patchValue(this.data);
      this.QualificationTab.controls['qualificationType'].patchValue(
        this.data.qualificationTypeId
      );
      this.QualificationTab.controls['birthDate'].patchValue('');
      this.QualificationTab.controls['lastFourSocialSecurityNumber'].patchValue(
        ''
      );
      if (res?.exemptionRequestType?.code == 'VOLREVOCATION') {
        this.ConfirmationTab.patchValue(this.data);
        this.ConfirmationTab.controls['waveRightToSue'].patchValue(
          this.data?.waveRightsToSue
        );
      }
      this.populateSignatureTabData(this.data);
      let rq = this.requestTypes.filter(
        (x) => x.id == this.data.exemptionRequestTypeId
      );

      this.validateAllFormFields(this.form);
    });
  }
  populateSignatureTabData(data: any) {
    this.SignatureTab.controls['firstName'].patchValue(
      data?.signatureFirstName
    );
    this.SignatureTab.controls['firstName'].updateValueAndValidity();
    this.SignatureTab.controls['middleName'].patchValue(
      data?.signatureMiddleName
    );
    this.SignatureTab.controls['middleName'].updateValueAndValidity();
    this.SignatureTab.controls['lastName'].patchValue(data?.signatureLastName);
    this.SignatureTab.controls['lastName'].updateValueAndValidity();
    this.SignatureTab.controls['suffix'].patchValue(data?.signatureSuffix);
    this.SignatureTab.controls['suffix'].updateValueAndValidity();
    this.SignatureTab.controls['title'].patchValue(data?.signatureTitle);
    this.SignatureTab.controls['title'].updateValueAndValidity();
    this.SignatureTab.controls['iCertify'].patchValue(data?.signatureICertify);
    this.SignatureTab.controls['iCertify'].updateValueAndValidity();
  }
  
  validateAllFormFields(formGroup: FormGroup) {
    Object.keys(formGroup.controls).forEach((field) => {
      const control = formGroup.get(field);
      if (control instanceof FormControl) {
        control.markAsTouched({ onlySelf: true });
      } else if (control instanceof FormGroup) {
        this.validateAllFormFields(control);
      }
    });
  }
  onCancel() {
    let dialogRef = this.dialog.open(WarningApplicationComponent, {
      data: {
        title: 'Warning',
        message: `Your application has not been completed. Leaving the page will cancel your application and no data will be saved. \n Click Leave to leave the page \n Click OK to continue entering your application?`,
      },
      disableClose: true,
    });
    dialogRef.afterClosed().subscribe((res) => {
      if (res.data == 'cancel') {
        const ereqType = this.externalStatusTypes.find(
         (x: { code: string }) => x.code == 'EXTSUBCANCELLED'
       )?.id;
       this.exemptionFilingRequestService
         .updateExternalRequestStatus(this.requestId, ereqType)
         .subscribe((res) => {
           this.routerService.navigateByUrl('/search');
         });
     }
    });
  }
  tabChanged(event: any) {
    console.log(event);
    this.selectedTab = event.tab?.textLabel;
  }

  Continue() {
    this.setNextTabIndex();
  }

  saveAndContinue() {
    this.validateAndSave(true);
  }

  validateAndSave(continueNextTab: Boolean) {
    console.log('validate and save' + continueNextTab);
    if (this.selectedTab == InternalTabTypes.VerificationTab) {
      if (!this.QualificationTab.valid) {
        return;
      }
    }
    if (this.selectedTab == InternalTabTypes.RequestcopyTab) {
      if (!this.RequestCopyTab.valid) {
        return;
      }
    }
    if (this.selectedTab == InternalTabTypes.ConfirmationTab) {
      if (!this.ConfirmationTab.valid) {
        this.dialog.open(ConfirmModalComponent, {
          data: {
            title: 'Warning',
            warning: true,
            message: `The Attestation checkboxes must be checked to continue.`,
          },
          disableClose: true,
        });
        return;
      }
    }
    if (this.selectedTab == InternalTabTypes.SignatureTab) {
      if (
        !this.SignatureTab.valid ||
        this.SignatureTab.controls['iCertify'].value == false
      ) {
        if (
          this.SignatureTab.controls['iCertify'].value == false ||
          this.SignatureTab.controls['iCertify'].value == 'false'
        ) {
          this.dialog.open(ConfirmModalComponent, {
            data: {
              title: 'Warning',
              warning: true,
              message: `You have not indicated "I Certify". \n Click OK to go back.`,
            },
            disableClose: true,
          });
        }
        return;
      }
    }
    this.saveTabsData(continueNextTab);
  }
  private refreshData() {
    this.isLoading = true;
    forkJoin({
      exemptionData:
        this.exemptionFilingRequestService.getExemptionFilingRequestDetail(
          this.requestId
        ),
    }).subscribe(({ exemptionData }) => {
      this.populateFormData(exemptionData);
      this.isLoading = false;
    });
  }

  private saveTabsData(continueNextTab: Boolean) {
    const errorMsg = 'Error occured while saving data.';
    console.log(this.selectedTab);
    this.isLoading = true;
    switch (this.selectedTab) {
      case InternalTabTypes.VerificationTab: {
        var tabdata = this.QualificationTab.value as QualificationTab;
        console.log(this.QualificationTab.value);
        this.exemptionFilingRequestService
          .saveRequestCopyVerificationTab(this.QualificationTab.value)
          .subscribe(
            (res: any) => {
              this.isLoading = false;
              if (res?.result) {
                if (continueNextTab) this.setNextTabIndex();
              } else {
                this.verificationError = res?.errorMessage;
              }
            },
            (error) => {
              this.isLoading = false;
              console.log(error);
            }
          );
        break;
      }
      case InternalTabTypes.RequestcopyTab: {
        var data = this.RequestCopyTab.value;
        this.exemptionFilingRequestService.saveRequestaCopyTab(data).subscribe(
          (res: any) => {
            this.isLoading = false;
            // this.refreshData();
            console.log(res);
            if (continueNextTab) this.setNextTabIndex();
          },
          (error) => {this.isLoading = false;}
        );
        break;
      }
      case InternalTabTypes.ConfirmationTab: {
        var confTab = this.ConfirmationTab.value as ConfirmationTab;
        console.log(confTab);
        this.exemptionFilingRequestService
          .saveConfirmationTab(confTab)
          .subscribe(
            (res: any) => {
              this.isLoading = false;
              this.refreshData();
              console.log(res);
              if (continueNextTab) this.setNextTabIndex();
            },
            (error) => {this.isLoading = false;}
          );
        break;
      }
      case InternalTabTypes.SignatureTab: {
        var sigTab = this.SignatureTab.value as SignatureTab;
        this.exemptionFilingRequestService.saveSignatureTab(sigTab).subscribe(
          (res: any) => {
            this.isLoading = false;
            // this.refreshData();
            console.log(res);
            if (continueNextTab) this.setNextTabIndex();
          },
          (error) => {this.isLoading = false;}
        );
        break;
      }
    }
  }
  private setNextTabIndex() {
    this.selectedIndex += 1;
  }

  previousStep() {
    this.selectedIndex -= 1;
  }

  private loadTypesData() {
    this.commonService.getQualificationTypes().subscribe((res) => {
      this.qualificationTypes = res;
    });
    this.commonService.getCountryTypes().subscribe((res) => {
      this.countryTypes = res;
    });
    this.commonService.getExternalStatusTypes().subscribe((res) => {
      this.externalStatusTypes = res;
    });
  }

  interceptTabChange(tab: MatTab, tabHeader: MatTabHeader, idx: number) {
    return false;
  }

  addValidators(tabName: string, fieldName: string, valdtrs: ValidatorFn) {
    let ctrl = (this.form.controls[tabName] as FormGroup)?.controls[
      fieldName
    ] as AbstractControl;
    ctrl.addValidators(valdtrs);
    ctrl.updateValueAndValidity();
  }

  clearValidators(tabName: string, fieldName: string) {
    let ctrl = (this.form.controls[tabName] as FormGroup)?.controls[fieldName];
    ctrl.clearValidators();
    ctrl.updateValueAndValidity();
  }

  ngOnInit(): void {
    this.requestId = +atob(this.router.snapshot.params.id);
    this.buildForm();
    this.loadData();
    this.router.queryParams.subscribe((params) => {
      console.log(params);
      if (params?.ifpf != null) {
        this.selectedIndex = 7;
        this.selectedTab == InternalTabTypes.PaymentTab;
        if (params.ifpf == btoa('true')) {
          this.dialog.open(ConfirmModalComponent, {
            data: {
              title: 'Warning',
              warning: true,
              message: `Online payment failed. \n Click Mail In button to print confirmation to send with your payment to the Bureau of Workers' Compensation. `,
            },
            disableClose: true,
          });
        }
      }
    });
  }

  private buildForm() {
    this.CreateForms();

    this.form = this.fb.group({
      QualificationTab: this.QualificationTab,
      RequestCopyTab: this.RequestCopyTab,
      ConfirmationTab: this.ConfirmationTab,
      SignatureTab: this.SignatureTab,
      PaymentTab: this.PaymentTab,
    });
  }

  private CreateForms() {
    console.log(this.requestId);
    this.QualificationTab = this.fb.group({
      ExemptionFilingRequestId: [this.requestId],
      qualificationType: [''],
      entityControlNumber: [''],
      filingEntityName: [''],
      firstName: [''],
      middleName: [''],
      lastName: [''],
      nameSuffix: [''],
      birthDate: ['', Validators.required],
      lastFourSocialSecurityNumber: [
        '',
        [Validators.required, Validators.minLength(4), Validators.maxLength(4)],
      ],
      contactPhone: ['', Validators.required],
      contactPhoneExtension: ['', [Validators.maxLength(6)]],
      contactEmail: ['', [Validators.required, Validators.email]],
      confirmEmail: ['', [Validators.required, Validators.email]],
    }); ///^[0-9]{10,10}$/
    this.RequestCopyTab = this.fb.group({
      id: [this.requestId],
      numberOfCopies: ['', Validators.required],
      sendToMode: ['', Validators.required],
      sendToName: ['', Validators.required],
      sendToAddressLine1: [''],
      sendToAddressLine2: [''],
      sendToAddressLine3: [''],
      sendToCity: [''],
      sendToState: [''],
      sendToZipCode: [''],
      sendToPhoneNumber: ['', Validators.required],
      sendToEmailAddress: ['', Validators.required],
    });
    this.ConfirmationTab = this.fb.group({
      id: [this.requestId],
      stillAffiliated: [''],
      attestToTCA: [''],
      waveRightToSue: ['', Validators.required],
      registeredApplicant: [''],
      doHaveInjury: ['', Validators.required],
    });
    this.SignatureTab = this.fb.group({
      id: [this.requestId],
      firstName: ['', Validators.required],
      middleName: [''],
      lastName: ['', Validators.required],
      title: [''],
      suffix: [''],
      iCertify: new FormControl('', [
        (control) => {
          return !control.value ? { required: true } : null;
        },
      ]),
    });
  }
}
